<div class="flex align-items-center" *ngIf="value">
  <div class="col-fixed px-0" [style.width.px]="50" *ngIf="!readonly">
    <button pButton icon="fas fa-trash" type="button" class="p-button-danger" (click)="remove.emit()">
    </button>
  </div>
  <div class="col pl-0">
    <p-autoComplete name="diagnostic_description_{{idx}}_{{turn}}" [(ngModel)]="value.cieHelp" [minLength]="3"
      dataKey="id" field="displayName" [suggestions]="suggestions" (completeMethod)="getSuggestions($event.query)"
      (onSelect)="fillWithSuggestion($event)" (onKeyUp)="onKeyUp(false)" inputStyleClass="uppercase ellipsis"
      [required]="!readonly" [readonly]="readonly" validation>
    </p-autoComplete>
  </div>
  <div class="col-fixed px-0 py-0 inline-flex justify-content-center" [style.width.px]="20"
    *ngIf="value.cieHelp && value.cieHelp.description">
    <i class="far fa-question-circle" [pTooltip]="value.cieHelp.description" tooltipPosition="left"></i>
  </div>
  <span class="col-fixed px-0 py-0 inline-flex justify-content-center" [style.width.px]="60">
    <p-radioButton name="radio-diagnostic_{{idx}}_{{turn}}" [value]="true" [(ngModel)]="value.isFinal"
      [disabled]="readonly">
    </p-radioButton>
  </span>
  <span class="col-fixed px-0 py-0 inline-flex justify-content-center" [style.width.px]="60">
    <p-radioButton name="radio-diagnostic_{{idx}}_{{turn}}" [value]="false" [(ngModel)]="value.isFinal"
      [disabled]="readonly"></p-radioButton>
  </span>
</div>